import { useMutation, useQuery, useQueryClient } from 'react-query';

import * as api from './api';
// import {

// } from './types';

// These queries and mutations use React hooks, which can only be called from within a functional
// component. Because of that we need to wrap them in functions like below. To access them in a
// functional component:
//   import { useQueries } from './queries';
//   const q = useQueries();
export const useQueries = () => {
  return {
    pageQuery,
    statisticQuery
  };
};

export const pageQuery = (path, options = {}) => {
  return useQuery(`pages[${path}]`, () => api.fetchPage(path), {
    retry: false,
    cacheTime: Infinity,
    staleTime: Infinity,
    ...options
  });
};

export const statisticQuery = (name, filters, options = {}) => {
  return useQuery([`statistics[${name}`, filters], () => api.fetchStatistic(name, filters), {
    retry: false,
    cacheTime: Infinity,
    staleTime: Infinity,
    ...options
  });
};
